const pad = n => String(n).padStart(2, '0');

const fmt = date =>
  `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}, ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

export const createAssistenteMock = () => ({
  whatsapp: {
    // null = ainda não sabemos — NÃO pintar "Desconectado" mentiroso no 1º frame
    conectado: null,
    numero: '—',
    conectados: '—',
    atualizado: '—',
    instancias: [],
  },
  ia: {
    ativa: null,
    ligada: null,
    atualizado: '—',
  },
  conversas: [],
  pausadasExtras: [],
  delay: { min: 1, max: 4 },
  followup: {
    ativo: false,
    minutos: 30,
    instrucoes: '',
  },
  notificacao: {
    ativa: false,
    telefone: '',
    mensagem: '',
  },
  prompt: '',
  treinadores: [],
  atividade: [],
});

export const formatNow = () => fmt(new Date());
